import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AngularExpansionModule } from "@app/angular-expansion/angular-expansion.module";
import { MaterialModule } from "@app/material.module";
import { EstimationStatisticsGraphModule } from "@app/shared/estimation-statistics-graph/estimation-statistics-graph.module";
import { SatPopoverModule } from "@ncstate/sat-popover";
import { TranslateModule } from "@ngx-translate/core";
import { ProjectFilterPopoverComponent } from "./project-filter-popover.component";

@NgModule({
	declarations: [ProjectFilterPopoverComponent],
	imports: [
		CommonModule,
		SatPopoverModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		ScrollingModule,
		TranslateModule,
		AngularExpansionModule,
		EstimationStatisticsGraphModule,
	],
	exports: [ProjectFilterPopoverComponent],
})
export class ProjectFilterPopoverModule {}
